import { HeroSection } from '../components/HeroSection';
import { ProductSections } from '../components/ProductSections';
import { BlogSection } from '../components/BlogSection';
import { SubscriptionSection } from '../components/SubscriptionSection';
import type { Product, WeightVariant } from '../components/ProductCard';

interface HomePageProps {
  onAddToCart: (product: Product, variant?: WeightVariant) => void;
  onProductClick: (product: Product) => void;
  onCatalogClick: () => void;
  onRecipeClick: (recipe?: any) => void;
  onRecipesClick: () => void;
}

export function HomePage({
  onAddToCart,
  onProductClick,
  onCatalogClick,
  onRecipeClick,
  onRecipesClick,
}: HomePageProps) {
  return (
    <>
      {/* Add background gradient for neural aesthetics */}
      <div
        className="fixed inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at top, rgba(245, 158, 11, 0.1) 0%, transparent 50%), radial-gradient(ellipse at bottom, rgba(217, 119, 6, 0.05) 0%, transparent 50%)',
          zIndex: -1,
        }}
      />

      <HeroSection onCatalogClick={onCatalogClick} />
      <ProductSections
        onAddToCart={onAddToCart}
        onProductClick={onProductClick}
        onViewAllClick={onCatalogClick}
      />
      <BlogSection
        onRecipeClick={onRecipeClick}
        onViewAllRecipesClick={onRecipesClick}
      />
      <SubscriptionSection />
    </>
  );
}
